import { useEffect, useState } from 'react'

export const useTimeout = (ms: number) => {
  const [val, setVal] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setVal(true)
    }, ms)
    return () => {
      clearTimeout(timeout)
    }
  }, [ms])

  return val
}
